import type { BlogPostCustom } from '@twisto/api-cms'

import { Post } from '../post'

import * as styles from './posts-grid.styles'

export const PostsGrid = ({ posts }: { posts: BlogPostCustom[] }) => (
  <div css={styles.grid}>
    {posts.map((post) => (
      <Post key={post.id} {...post} />
    ))}
  </div>
)
